<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Online Exam Result</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon"
            @click="handleBackButton"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-chevron-left" />
            </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
                <p class="text-muted"><b>Online exam result </b></p>
            <display-class-section-exam :rolesetting="pagepermission" :status="statId" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplayClassSectionExam from '@/components/online-exam/result/index'

export default {
  components: {
    DisplayClassSectionExam,
  },
  data: function() {
    return {
      loading: false,
      pagepermission: {},
    }
  },
  mounted: function() {
    // console.log('geting param from caller ....', this.$route.params.pagepermission)
    this.pagepermission = this.$route.params.pagepermission
  },
  computed: {
    examId: function() {
      return this.$route.params.examId
    },
    // clId: function() {
    //   return this.$route.params.classId
    // },
    // secId: function() {
    //   return this.$route.params.sectionId
    // },
    statId: function() {
      return this.$route.params.statusId
    },
  },
  methods: {
    handleBackButton() {
      this.$router.push({ name: 'manageonlineexam' })
    },
  },
}
</script>
